export interface Article {
  slug: string;
  title: string;
  excerpt: string;
  content: string;
  category: string;
  categorySlug: string;
  date: string;
  readTime: string;
  imageSeq: string;
}

export const articles: Article[] = [
  {
    slug: "guobiao-majiang-wanzheng-guize",
    title: "国标麻将完整规则详解：从入门到精通",
    excerpt: "国标麻将是中国官方认可的竞赛麻将标准，包含81个番种。本文详细介绍国标麻将的完整规则、计分方式和常用策略。",
    content: `<p>国标麻将是国家体育总局于1998年颁布的竞赛麻将规则，目前被广泛用于国内外正式麻将比赛。与各地民间玩法不同，国标麻将强调技术性和规范性，是麻将竞技化的代表性规则。</p><h2>一、基本牌具</h2><p>国标麻将使用144张牌，包括万子（1-9万各4张）、筒子（1-9筒各4张）、条子（1-9条各4张）、风牌（东南西北各4张）、箭牌（中发白各4张），以及8张花牌（春夏秋冬、梅兰竹菊）。</p><h2>二、基本流程</h2><p>四位玩家各砌17墩牌。庄家掷骰确定开牌位置，每人先取12张牌（分三次，每次4张），然后庄家跳牌取2张，其余玩家各取1张，最终庄家14张，闲家13张。游戏进行中，玩家轮流摸牌、出牌，通过吃、碰、杠等操作组合手牌。</p><h2>三、和牌条件</h2><p>国标麻将的和牌必须满足以下条件：手牌由4组面子（顺子或刻子）和1对将牌组成；必须达到最低8番的起和线；所有番种计算必须符合标准定义。</p><h2>四、81个番种概览</h2><p>国标麻将的81个番种分为12个系列，包括字牌系列、序数牌系列、刻子系列等。番数从1番到88番不等，88番为最高番种（如大四喜、大三元、九莲宝灯等）。</p><h2>五、常用策略</h2><p>1. 起手评估：根据初始手牌判断可发展的番种方向。2. 防守意识：注意观察对手出牌，避免点炮。3. 番种组合：尝试将多个番种组合以达到更高总分。</p>`,
    category: "国标麻将",
    categorySlug: "guobiao-majiang",
    date: "2026-08-05",
    readTime: "8分钟",
    imageSeq: "article-guobiao-01",
  },
  {
    slug: "sichuan-majiang-xuezhan-dadi",
    title: "四川麻将血战到底：规则、技巧与实战心得",
    excerpt: "四川麻将以其独特的血战到底规则闻名全国。本文深度解析四川麻将的核心规则、缺一门策略以及实战中的制胜技巧。",
    content: `<p>四川麻将（川麻）是中国最具地方特色的麻将玩法之一，流行于四川、重庆及周边地区。其最大的特点是"血战到底"——一家和牌后，其余三家继续对战，直到只剩最后一家未和牌或牌墙摸完为止。</p><h2>一、核心规则</h2><p>1. 缺一门：玩家必须在和牌前确定自己缺少的一种花色（万、筒、条任选其一），缺门未完成前不能和牌。2. 刮风下雨：杠牌时，其他玩家需要向杠牌者支付一定分数。3. 查叫：牌墙摸完后未和牌的玩家需要互相检查手牌。</p><h2>二、计分规则</h2><p>四川麻将的计分以"番"为单位：平胡1番、对对胡2番、清一色4番、七对4番、清对8番、龙七对16番等。杠牌单独计分：明杠1番、暗杠2番。</p><h2>三、实战技巧</h2><p>1. 缺门选择策略：优先缺数量最少的花色，保留数量最多的花色作为发展方向。2. 血战心理：一家和牌后，要重新评估局势，调整策略。3. 杠牌时机：关键牌型即将成型时谨慎杠牌，避免破坏已有结构。</p>`,
    category: "四川麻将",
    categorySlug: "sichuan-majiang",
    date: "2026-07-28",
    readTime: "7分钟",
    imageSeq: "article-sichuan-01",
  },
  {
    slug: "guangdong-majiang-ruhe-kuaisu-shangshou",
    title: "广东麻将快速上手：鸡平胡与推倒胡玩法解析",
    excerpt: "广东麻将是华南地区最受欢迎的麻将玩法，本文介绍鸡平胡和推倒胡两种主流规则，帮助新手快速掌握广东麻将精髓。",
    content: `<p>广东麻将（广麻）流行于广东、香港、澳门以及海外华人社区。其规则相对简洁明快，节奏快、易上手，非常适合休闲娱乐和社交对战。</p><h2>一、鸡平胡规则</h2><p>鸡平胡是广东麻将的基础玩法：1. 使用136张牌（不含花牌）。2. 可碰不可吃。3. 只能自摸和牌，不能点炮。4. 和牌牌型为4组面子+1对将牌。5. 鬼牌（百搭）可代替任意牌使用。6. 番数计算相对简单。</p><h2>二、推倒胡规则</h2><p>推倒胡是另一种流行的广东麻将变体：1. 规则更加简化，和牌条件宽松。2. 没有番数要求，只要牌型完整即可和牌。3. 可以抢杠和牌。4. 支持点炮和自摸两种和牌方式。</p><h2>三、广东麻将特色术语</h2><p>鸡糊（无番和牌）、平糊（基本和牌）、对对糊（全是刻子）、混一色（一种花色+字牌）、清一色（纯一种花色）、十三幺（特殊牌型）等。</p>`,
    category: "广东麻将",
    categorySlug: "guangdong-majiang",
    date: "2026-07-20",
    readTime: "6分钟",
    imageSeq: "article-guangdong-01",
  },
  {
    slug: "majiang-chuxuezhe-bibei-jiqiao",
    title: "麻将初学者必备技巧：五个让你快速提升的实用策略",
    excerpt: "刚学麻将总是输？本文分享五个实用麻将技巧，帮助初学者快速提升牌技，从菜鸟变身牌桌高手。",
    content: `<p>麻将入门看似简单，但要真正打好并不容易。很多初学者学完基本规则后上桌实战，却发现总是输多赢少。本文将分享五个实用技巧，帮助你快速提升麻将水平。</p><h2>技巧一：学会读牌</h2><p>读牌是指通过观察其他玩家打出的牌来推断他们的手牌情况。注意观察每个玩家打出牌的花色和数字，可以大致判断他们在做什么牌型。例如，某玩家连续打出万子，很可能万子不是他的主要方向。</p><h2>技巧二：控制出牌节奏</h2><p>不要每次都快速出牌，适当放慢速度可以让你有更多时间思考。同时，观察对手的反应速度也能获取信息——某些玩家在犹豫时往往意味着手牌接近听牌。</p><h2>技巧三：防守优先于进攻</h2><p>初学者容易犯的错误是只顾自己和牌，忽视防守。当你判断某位玩家可能已经听牌时，应该优先打安全牌，避免点炮。记住：不点炮就是赢。</p><h2>技巧四：灵活调整策略</h2><p>不要从一开局就死守一种牌型。根据摸牌情况和对手出牌及时调整策略。比如原本想做清一色，但摸牌不顺，可以及时转向混一色或平胡。</p><h2>技巧五：管理好自己的心态</h2><p>麻将是一项需要冷静思考的游戏。无论赢多还是输多，都要保持平稳心态。情绪波动会影响判断，导致失误。记住：麻将打的是耐心和心态。</p>`,
    category: "麻将技巧",
    categorySlug: "majiang-jiqiao",
    date: "2026-07-15",
    readTime: "5分钟",
    imageSeq: "article-tips-01",
  },
  {
    slug: "majiang-lishi-wenhua-qiyuan",
    title: "麻将的历史起源与文化传承：从古代博戏到世界智力运动",
    excerpt: "麻将作为中国国粹，有着数百年的悠久历史。本文追溯麻将的起源、演变过程，探讨其在中国文化中的独特地位。",
    content: `<p>麻将被誉为中国"国粹"，是世界上最受欢迎的桌上游戏之一。据不完全统计，全球有超过6亿麻将爱好者。这项凝聚中华智慧的游戏，有着深厚的历史文化底蕴。</p><h2>一、麻将的起源</h2><p>关于麻将的起源，学界有多种说法。最广为接受的观点是麻将从明代的"马吊牌"演变而来。马吊牌是一种纸牌游戏，共40张牌，分为四门。到了清代，马吊牌逐渐演变为"麻雀牌"，牌数增加，规则也更加复杂。</p><h2>二、麻将名称的由来</h2><p>"麻将"一词源于"麻雀"的谐音。在吴语方言中，"麻雀"读作"麻将"，后演变为"麻将"。另一种说法是麻将的创始人为纪念一位名叫"万秉迢"的人，取其名中的"万"字，加上"饼（筒）"和"条（索）"组成了万、筒、条三门牌。</p><h2>三、麻将的传播与演变</h2><p>19世纪末20世纪初，麻将通过通商口岸传入日本和西方国家。1920年代，麻将在美国掀起热潮，成为上流社会的流行娱乐。各地在麻将传播过程中形成了各具特色的地方规则，如广东麻将、四川麻将、台湾麻将等。</p><h2>四、麻将文化的当代价值</h2><p>如今，麻将不仅是娱乐活动，更是一项智力运动。国际麻将联盟致力于推动麻将的国际化与标准化。2017年，麻将正式被国际智力运动联盟认定为第六大智力运动。</p>`,
    category: "麻将文化",
    categorySlug: "majiang-wenhua",
    date: "2026-07-08",
    readTime: "7分钟",
    imageSeq: "article-history-01",
  },
  {
    slug: "majiang-jibenshuyu-quanjie",
    title: "麻将基本术语全解：从吃碰杠到听牌和牌",
    excerpt: "刚接触麻将被各种术语搞晕了？本文全面梳理麻将常用术语，从最基础的吃、碰、杠到听牌、和牌，让你轻松理解。",
    content: `<p>刚开始学麻将的新手往往会遇到一个难题：老玩家嘴里说的各种术语听不懂。吃、碰、杠、听、和、自摸、点炮……这些词汇到底是什么意思？本文将系统梳理麻将的基本术语，帮助新手快速融入麻将世界。</p><h2>一、基本操作术语</h2><p><strong>摸牌</strong>：从牌墙最前面取一张牌到手牌中。<strong>出牌</strong>：从手牌中选择一张打出到牌池。<strong>吃牌</strong>：当上家打出的牌可以与你手牌中的两张组成顺子时，可以选择吃牌。<strong>碰牌</strong>：当任意玩家打出的牌与你手牌中的两张相同时，可以选择碰牌，组成刻子。<strong>杠牌</strong>：当获得四张相同的牌时，可以选择杠牌，获得额外摸牌机会。</p><h2>二、牌型状态术语</h2><p><strong>听牌</strong>：手牌距离和牌只差一张的状态。<strong>和牌</strong>：手牌满足规定的和牌条件，赢得本局。<strong>自摸</strong>：自己摸到的牌使自己完成和牌。<strong>点炮</strong>：打出的牌使其他玩家完成和牌。</p><h2>三、常见番种术语</h2><p><strong>平胡</strong>：最基本的和牌牌型，由四个顺子和一对将牌组成。<strong>对对胡</strong>：全部由刻子（或杠）组成的和牌。<strong>清一色</strong>：全部由同一花色的牌组成的和牌。<strong>混一色</strong>：由一种花色牌和字牌组成的和牌。<strong>七对</strong>：由七个对子组成的特殊和牌。</p>`,
    category: "新手入门",
    categorySlug: "xinshou-rumen",
    date: "2026-06-30",
    readTime: "6分钟",
    imageSeq: "article-terms-01",
  },
  {
    slug: "guobiao-majiang-gaofen-fanzhong",
    title: "国标麻将高分番种攻略：如何打出88番大牌",
    excerpt: "想在国际麻将比赛中取得好成绩？本文详细解析国标麻将中的高番值番种，教你如何组合番种打出惊艳高分。",
    content: `<p>在国标麻将比赛中，能够打出高番值的牌型是获得优胜的关键。88番的最高番种虽然可遇不可求，但通过合理的牌型规划和番种组合，64番甚至更高的成绩是完全可以打出来的。本文将重点介绍高分番种的实战攻略。</p><h2>一、88番顶级番种</h2><p>大四喜（东南西北各三张+任意将牌）、大三元（中发白各三张+任意一对+任意面子）、九莲宝灯（1112345678999+同色任意一张）、四杠（拥有四个杠）、绿一色（全部为23468条和发字）等。</p><h2>二、64番番种</h2><p>小四喜（其中三种风牌各三张+另一种一对+任意面子）、小三元（其中两种箭牌各三张+另一种一对+任意面子）、字一色（全部由字牌组成）、清幺九（全部由1和9的序数牌组成）等。</p><h2>三、番种组合策略</h2><p>国标麻将的计分采用番种累加制，因此合理组合多个中小番种往往比追求单个高分番种更实际。例如：混一色（6番）+ 碰碰胡（6番）+ 全求人（6番）= 18番，再加上一些1-2番的小番种，轻松突破20番。</p><h2>四、实战建议</h2><p>建议新手先掌握2-8番的中小番种组合，逐步积累经验后再挑战高番值牌型。在比赛中，稳定达到8番起和线比追求高分更为重要。</p>`,
    category: "国标麻将",
    categorySlug: "guobiao-majiang",
    date: "2026-06-22",
    readTime: "9分钟",
    imageSeq: "article-guobiao-02",
  },
  {
    slug: "shouji-majiang-tuijian",
    title: "2026年最受欢迎的手机麻将App推荐与对比评测",
    excerpt: "想用手机玩麻将？本文对比评测目前最受欢迎的几款手机麻将App，从界面、玩法、用户体验等方面帮你选择最适合的。",
    content: `<p>随着移动互联网的发展，手机麻将已经成为越来越多麻将爱好者的首选。无需约人、无需场地，随时随地打开手机就能来一局。本文将对比当前市场上几款主流手机麻将App，帮助你找到最适合自己的那一款。</p><h2>一、选择手机麻将的关键因素</h2><p>1. 玩法丰富度：是否支持你喜欢的麻将规则。2. 玩家数量：在线人数是否足够多，能否快速匹配。3. 界面设计：UI是否美观、操作是否流畅。4. 公平性：是否有防作弊机制。5. 社交功能：是否支持好友对战、语音聊天等。</p><h2>二、热门App推荐</h2><p>市面上优秀的手机麻将应用各有特色：有些主打国标麻将的专业竞技，有些专注地方麻将的休闲娱乐，还有一些以社交互动为核心卖点。建议根据自己的需求选择：竞技型玩家选专业平台，休闲玩家选社交属性强的应用。</p><h2>三、在线麻将的优势</h2><p>相比线下麻将，在线麻将具有以下优势：随时随地对战、智能计分防作弊、多种玩法一键切换、新手教程和提示功能、比赛和排行榜系统等。对于想提升麻将技术的玩家来说，在线麻将提供了大量实战练习机会。</p>`,
    category: "麻将技巧",
    categorySlug: "majiang-jiqiao",
    date: "2026-06-15",
    readTime: "6分钟",
    imageSeq: "article-apps-01",
  },
];